import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m7 7 10 10-5 5V2l5 5L7 17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20.83 14.83a4 4 0 0 0 0-5.66", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 12h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BluetoothSearching";
const BluetoothSearching = memo(themed(Icon));
export {
  BluetoothSearching
};
//# sourceMappingURL=bluetooth-searching.js.map
